<template>
  <div class="d-flex flex-column gap-3 w-100">
    <div
      v-for="action in actions"
      :key="`workflow-action-${action.id}`"
      class="card border rounded-4 shadow-sm"
    >
      <div class="card-body p-3 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
        <div>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <p class="fw-bold text-xs mb-0">{{ action.name || action.action_name }}</p>
            <span
              class="badge rounded-pill px-3 py-2"
              :class="Number(actionUsageById[action.id] || 0) > 0 ? 'text-primary bg-primary-subtle' : 'text-secondary bg-light'"
            >
              {{ Number(actionUsageById[action.id] || 0) }} use{{ Number(actionUsageById[action.id] || 0) === 1 ? '' : 's' }} in current workflow
            </span>
          </div>
          <p class="text-secondary text-xxs mb-0 mt-1">{{ action.description || 'No description provided.' }}</p>
        </div>

        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="$emit('edit', action)"
          >
            Edit
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            :disabled="actionDeleteRunningId === action.id"
            @click="$emit('delete', action.id)"
          >
            {{ actionDeleteRunningId === action.id ? 'Deleting...' : 'Delete' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="!actions.length" class="card border rounded-4 bg-white bg-opacity-75">
      <div class="card-body py-5 px-3 text-center">
        <p class="fw-bold text-xs mb-1">No actions yet</p>
        <p class="text-secondary text-xxs mb-0">
          Create reusable actions for transitions and section access.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionList',
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    actionUsageById: {
      type: Object,
      default: () => ({}),
    },
    actionDeleteRunningId: {
      type: Number,
      default: null,
    },
  },
  emits: ['edit', 'delete'],
};
</script>
